/**
 * Created by xing.lin on 2019/6/20.
 */
export default {
    data(){
        return {
            errmsg:'',
            canSubmit:false,
        }
    },
    methods: {
        check(val, validates){
            var errmsg ="";
            for(let i = 0; i<validates.length; i++){
                if(validates[i].required){
                    if(val === "" || val === undefined || val === null){
                        errmsg = validates[i].errmsg || this.$t('common.fill');
                        break;
                    }
                }else if(typeof validates[i].rule == "function"){
                    if(!validates[i].rule(val)){
                        errmsg = validates[i].errmsg || this.$t('common.fillError');
                        break;
                    }
                }else if(Object.prototype.toString.call(validates[i].rule) == "[object RegExp]"){
                    if(!validates[i].rule.test(val)){
                        errmsg = validates[i].errmsg || this.$t('common.fillError');
                        break;
                    }
                }
            }
            return errmsg ? errmsg : true
        },
        checkParams(arr){
            for(let i=0, len = arr.length; i<len; i++){
                this.canSubmit = false;
                this.errmsg = "";
                var res = this.check(arr[i].value,arr[i].rules);
                if(res === true){
                    this.canSubmit = true
                }else{
                    this.errmsg = res;
                    break;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixin/formValidate.js